import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=aed04da0&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupComponent.vue?vue&type=style&index=0&id=aed04da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed04da0",
  null
  
)

export default component.exports